document.addEventListener('DOMContentLoaded', () => {

    const el = document.querySelector('.c-popup');
    if(!el) return;

    el.querySelector('.c-popup__close').addEventListener('click', ()=> {
        document.body.classList.remove('show-popup');
        localStorage.setItem('popup', new Date().toISOString());
    });

    const lastPopupDate = localStorage.getItem('popup');

    if(!lastPopupDate || hasOneDayPassed(lastPopupDate)) {
        document.body.classList.add('show-popup');
    }


    function hasOneDayPassed(dateString) {
        const lastDate = new Date(dateString);
        const currentDate = new Date();

        const timeDifference = currentDate - lastDate;

        // 24h * 60min * 60sek * 1000ms = 86400000ms
        return timeDifference > (24 * 60 * 60 * 1000);
    }

});
